import React from 'react'
import { View, StyleSheet } from 'react-native'
import { BtText } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'

interface OnlineConnectedBadgeProps {
  style?: any
  reconnectionRequired?: boolean
}

export const OnlineConnectedBadge: React.FC<OnlineConnectedBadgeProps> = ({
  style,
  reconnectionRequired = false,
}) => {
  const { t } = useTranslation('global')
  return (
    <View
      style={composeStyle(
        styles.view,
        style,
        reconnectionRequired && styles.warning,
      )}
    >
      <BtText style={styles.text}>
        {reconnectionRequired
          ? t('Wallet.disconnected')
          : t('Wallet.online-connected')}
      </BtText>
    </View>
  )
}

const styles = StyleSheet.create({
  view: {
    height: 22,
    maxWidth: 210,
    backgroundColor: '#33B3F5',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    borderRadius: 5,
    paddingHorizontal: 8,
    flex: 2,
  },
  text: {
    fontWeight: '500',
    fontSize: 12,
    color: 'white',
    lineHeight: 20,
  },
  warning: {
    backgroundColor: '#DB2424',
  },
})
